export default "__VITE_ASSET__6a9feb91__"